<template>
  <v-container>
    <v-row class="mb-6 align-center justify-space-between">
      <v-col cols="12" md="6" class="d-flex align-center">
        <v-icon
          large
          class="mr-3"
          color="primary"
          @click="$router.push({ name: 'admin.sucursalesHome' })"
          style="cursor: pointer"
        >
          mdi-arrow-left
        </v-icon>
        <h2 class="text-h5 font-weight-bold mb-0">Nueva sucursal</h2>
      </v-col>

      <v-col cols="12" md="6" class="text-md-right text-left">
        <!-- Botones u otras acciones opcionales acá -->
      </v-col>
    </v-row>

    <v-row justify="start">
      <v-col cols="12" md="12">
        <v-row justify="start" class="mt-4">
          <v-col cols="8">
            <SucursalForm
              :sucursal="sucursal"
              :provincias="provincias"
              :isUpdate="false"
              @process-sucursal="registrarSucursal"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SucursalForm from "@/components/sucursal/sucursal.form.vue";

export default {
  name: "SucursalEmpresaRegistrar",

  components: {
    SucursalForm,
  },

  data() {
    return {
      provincias: [],
      empresaUuid: null,
      sucursal: {
        nombre: "",
        direccion: "",
        telefono: null,
        encargado: null,
        localidad: { id: null },
        condicionIva: null,
        telegram_chat_id: null,
      },
    };
  },

  async mounted() {
    this.empresaUuid = this.$route.params.uuid_empresa || null;
    await this.fetchProvincias();
  },

  methods: {
    async fetchProvincias() {
      try {
        const response = await this.axios.get("/soporte/provincias");
        this.provincias = response.data;
      } catch (error) {
        console.error("Error al obtener provincias", error);
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "error",
          text: "No se pudieron cargar las provincias",
          icon: "mdi-alert-circle",
        });
      }
    },

    async registrarSucursal() {
      try {
        let url = "/sucursales/";
        if (this.empresaUuid) {
          url += `?uuid_empresa=${this.empresaUuid}`;
        }

        await this.axios.post(url, this.sucursal);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "success",
          text: "Sucursal registrada",
          icon: "mdi-check",
          timeout: 3000,
        });

        this.$router.push("/sucursales");
      } catch (error) {
        console.error("Error al registrar sucursal", error);
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "error",
          text: "Hubo un problema al registrar la sucursal",
          icon: "mdi-alert",
          timeout: 4000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
